module.exports = __webpack_public_path__ + "img/img-12.d0954d22.png";